"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var edit_lesson_plan_html_1 = __importDefault(require("./edit-lesson-plan.html"));
var edit_lesson_plan_controller_1 = __importDefault(require("./edit-lesson-plan.controller"));
var roadmap_resolves_1 = require("../../roadmaps/roadmap-resolves");
function getCourseTypes(CourseTypesModel) {
    return CourseTypesModel.get().then(function (response) {
        return response.courseTypes;
    });
}
getCourseTypes.$inject = ["CourseTypesModel"];
function getSessionTypes(DriveSessionTypesModel) {
    return DriveSessionTypesModel.get().then(function (response) {
        return response.sessionTypes;
    });
}
getSessionTypes.$inject = ["DriveSessionTypesModel"];
function getLessonPlan(LessonPlanModel, $stateParams) {
    return LessonPlanModel.show(parseInt($stateParams.lessonPlanID, 10)).then(function (response) {
        return response.lesson_plan;
    });
}
getLessonPlan.$inject = ["LessonPlanModel", "$stateParams"];
function config($stateProvider, $urlRouterProvider) {
    $stateProvider.state("drivecoach.admin.lessonplans.edit", {
        url: "/:lessonPlanID/edit-workflow",
        controller: "EditLessonPlanController",
        controllerAs: "vm",
        template: edit_lesson_plan_html_1.default,
        resolve: {
            courseTypes: getCourseTypes,
            sessionTypes: getSessionTypes,
            lessonPlan: getLessonPlan,
            documentTemplates: roadmap_resolves_1.getDocumentTemplates,
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider"];
exports.default = angular_1.default
    .module("drivecoach.admin.lessonplans.edit", [])
    .config(config)
    .controller("EditLessonPlanController", edit_lesson_plan_controller_1.default);
